import React, { useEffect, useState } from 'react'
import { useExercise } from '../ExerciseProvider'
import { useTranslation } from '~/hooks/useTranslation'
import { Input } from '~/lib/ui/input'
import { Button } from '~/lib/ui/button'
import YnsIcon from '~/components/icons/YnsIcon'

const LeisureActivitiesPageOne = ({ categories, ...sectionProps }) => {
  return (
    <div className="flex flex-col gap-8">
      {categories.map((category, idx) => (
        <LeasureActivityCategory
          key={`leisure-cat-${idx}`}
          category={category}
          {...sectionProps}
        />
      ))}
    </div>
  )
}

export default LeisureActivitiesPageOne

const LeasureActivityCategory = ({ category, ...sectionProps }) => {
  const { t } = useTranslation('leisure_activities')
  const { name, description, slug } = category
  const { setContinueButtonDisabled, getResponse } = useExercise()

  const initialActivities = getResponse(0, slug) || ['']

  const [activities, setActivities] = useState(initialActivities)

  useEffect(() => {
    const isEmpty = activities.every((a) => a === '')
    setContinueButtonDisabled(isEmpty)
  }, [activities, setContinueButtonDisabled])

  const textAreaProps = { activities, setActivities, slug }

  const handleAddAnother = () => {
    setActivities([...activities, ''])
  }

  return (
    <div>
      <div className="subtitle">{name}</div>
      <p>{description}</p>
      {activities.map((activity, idx) => (
        <UserActivity
          key={`leisure-activity-${idx}`}
          idx={idx}
          activities={activities}
          activity={activity}
          {...sectionProps}
          {...textAreaProps}
        />
      ))}
      <Button variant="link" className="mt-4" onClick={handleAddAnother}>
        + {t('pages.0.add')}
      </Button>
    </div>
  )
}

const UserActivity = ({ activity, ...props }) => {
  return activity === '' ? (
    <ActivityInput {...props} />
  ) : (
    <ActivityInput activity={activity} {...props} />
  )
}

const ActivityInput = ({ activity, activities, setActivities, slug, idx }) => {
  const { handleChange } = useExercise()
  const { t } = useTranslation('leisure_activities')

  const [textResponse, setTextResponse] = useState(activity || '')

  const handleBlur = (e) => {
    const isDuplicate = activities.some((a) => a === textResponse)
    if (textResponse === '' || isDuplicate) {
      return
    } else {
      const getNewActivities = () => {
        if (activities[activities.length - 1] === '') {
          return activities.slice(0, -1)
        }
        return activities
      }
      const newActivities = [...getNewActivities(), textResponse]
      setActivities(newActivities)
      // setAllActivities((prev) => ({ ...prev, [slug]: newActivities }))
      handleChange(0, slug, e, newActivities)
    }
  }

  const handleRemove = (e) => {
    if (activities.length === 1) {
      setTextResponse('')
      setActivities([''])
      // setAllActivities({ ...activities, [slug]: [''] })
      handleChange(0, slug, e, [''])
      return
    }
    const newActivities = activities.filter((_, i) => i !== idx)
    setActivities(newActivities)
    setTextResponse(newActivities[idx])
    // setAllActivities({ ...activities, [slug]: newActivities })
    handleChange(0, slug, e, newActivities)
  }

  const disableRemove = activities.length === 1 && textResponse === ''

  return (
    <div className="flex items-center gap-4">
      <Input
        id="volunteering-ideas"
        onChange={(e) => {
          setTextResponse(e.target.value)
        }}
        value={textResponse}
        className="mt-4"
        onBlur={handleBlur}
      />
      <div>
        <Button
          disabled={disableRemove}
          onClick={handleRemove}
          title={t('pages.0.remove')}
          variant="ghost"
        >
          <YnsIcon name="Trash" />
        </Button>
      </div>
    </div>
  )
}
